import Script from 'next/script';
import { Component } from '@headless-workspace/typings';

type JSONStructuredSchemaProps = {
    content: unknown;
};

export const JSONStructuredSchema: Component<JSONStructuredSchemaProps> = ({ content }) => {
    return (
        <Script
            type={'application/ld+json'}
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(content),
            }}
        />
    );
};
